import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modern-data-architecture',
  templateUrl: './modern-data-architecture.component.html',
  styleUrls: ['./modern-data-architecture.component.sass']
})
export class ModernDataArchitectureComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
